import React from 'react';
import './loading.css';

function Loading() {
  return (
    <div className="loader_nova">Chargement...</div>
  )
}

export default Loading